<template>
    <div class="returnPostage">
        <!-- 顶部导航栏 -->
        <nav class="navbar">
            <div class="nav-container">
                <ul class="nav-links">
                    <li class="nav-item">
                        <a href="#" @click="isShowDeviceManagement = false" class="nav-link active">卡板信息</a>
                    </li>
                    <li class="nav-item">
                        <a href="#" @click="showDeviceManagement()" class="nav-link">设备管理</a>
                    </li>
                </ul>
            </div>
        </nav>
        <ShebeiMgr v-if="isShowDeviceManagement" />
        <!-- 查询区域 -->
        <section class="section2" v-if="!isShowDeviceManagement">
            <div class="form-container">
                <div class="form-group">
                    <div class="input-wrapper">
                        <input id="cardNumber" v-model="userInfo.mobile" type="text" placeholder="请输入你要查询的卡号">
                    </div>
                </div>
                <div class="button-group">
                    <mt-button type="primary" @click="toSelectSimInfo()" class="button-1">查询信息</mt-button>
                    <mt-button type="primary" @click="updateSim()" class="button-5">更新信息</mt-button>

                    <mt-button type="primary" @click="toReload()" class="button-2">刷新网络</mt-button>
                    <mt-button type="primary" @click="toActive()" class="button-3">一键复机</mt-button>
                    <mt-button type="primary" @click="toPause()" class="button-4">一键停机</mt-button>
                </div>
            </div>
        </section>

        <!-- 信息展示区域 -->
        <section class="section1" v-if="!isShowDeviceManagement">
            <h2 class="section-title" v-if="orderInfo.userCity && orderInfo.userCity.length > 1">使用地址：{{ orderInfo.userCity
            }}</h2>
            <h2 class="section-title" v-else>基础信息</h2>
            <ul>
                <li class="with-copy-btn">
                    <label>ICCID：</label>
                    <div class="value-wrapper">
                        <span>{{ orderInfo.iccid }}</span>
                        <button class="copy-btn" @click="copyToClipboard(orderInfo.iccid, $event)" ref="iccidCopyBtn">
                            <i class="fa fa-copy"></i>
                            <span class="copy-text">复制</span>
                        </button>
                    </div>
                </li>
                <li class="with-copy-btn">
                    <label>接入号：</label>
                    <div class="value-wrapper">
                        <span>{{ orderInfo.intoNo }}</span>
                        <button class="copy-btn" @click="copyToClipboard(orderInfo.intoNo, $event)"
                            ref="accessNumberCopyBtn">
                            <i class="fa fa-copy"></i>
                            <span class="copy-text">复制</span>
                        </button>
                    </div>
                </li>
                <li class="with-copy-btn">
                    <label>虚拟号：</label>
                    <div class="value-wrapper">
                        <span>{{ orderInfo.vriNo }}</span>
                        <button class="copy-btn" @click="copyToClipboard(orderInfo.vriNo, $event)"
                            ref="virtualNumberCopyBtn">
                            <i class="fa fa-copy"></i>
                            <span class="copy-text">复制</span>
                        </button>
                    </div>
                </li>
                <li class="with-copy-btn">
                    <label>手机号：</label>
                    <div class="value-wrapper">
                        <span>{{ orderInfo.userPhone }}</span>
                        <button class="copy-btn" @click="copyToClipboard(orderInfo.userPhone, $event)"
                            ref="virtualNumberCopyBtn">
                            <i class="fa fa-copy"></i>
                            <span class="copy-text">复制</span>
                        </button>
                    </div>
                </li>


                <li>
                    <label>卡余额：</label>
                    <span>{{ orderInfo.userAmount }}</span>
                </li>
                <li>
                    <label>实名状态：</label>
                    <span style="color: red;" v-if="orderInfo.authState == '未实名'">{{ orderInfo.authState }}</span>
                    <span style="color: #309200;" v-else>{{ orderInfo.authState }}</span>
                </li>
                <li>
                    <label>卡状态：</label>
                    <span style="color: red;" v-if="orderInfo.simState == '停机'">{{ orderInfo.simState }}</span>
                    <span style="color: #007BFF;" v-else-if="orderInfo.simState == '已激活'">{{ orderInfo.simState }}</span>
                    <span style="color: #7d7d5d;" v-else>{{ orderInfo.simState }}</span>
                </li>
                <li>
                    <label>是否冻结：</label>
                    <span v-if="orderInfo.dongName && orderInfo.dongName.length > 4">{{ orderInfo.dongName }}</span>
                    <span v-else>{{ orderInfo.dongName }}</span>
                </li>
                <li>
                    <label>停机原因：</label>
                    <span style="color: red;" v-if="orderInfo.stopName && orderInfo.stopName.length > 4">{{
                        orderInfo.stopName
                    }}</span>
                    <span v-else>{{ orderInfo.stopName }}</span>
                </li>
                <li>
                    <label>总流量：</label>
                    <span>{{ orderInfo.totalData }}</span>
                </li>
                <li>
                    <label>已使用流量：</label>
                    <span>{{ orderInfo.useData }}</span>
                </li>
                <li>
                    <label>剩余流量：</label>
                    <span>{{ orderInfo.remainData }}</span>
                </li>
                <li>
                    <label>在用套餐：</label>
                    <span>{{ orderInfo.useName }}</span>
                </li>
                <li>
                    <label>过期时间：</label>
                    <span>{{ orderInfo.useTime }}</span>
                </li>
                <li>
                    <label>是否充值次月：</label>
                    <span>{{ orderInfo.nextName }}</span>
                </li>
                <li v-if="orderInfo.cmccSim && orderInfo.cmccSim.length>2">
                    <label>设备移动卡：</label>
                    <span>{{ orderInfo.cmccSim }}</span>
                    <button class="copy-btnLoad" @click="switchQuery(orderInfo.cmccSimIccid)">切换查询</button>
                </li>
                <li v-if="orderInfo.cuccSim && orderInfo.cuccSim.length>2">
                    <label>设备联通卡：</label>
                    <span>{{ orderInfo.cuccSim }}</span>
                    <button class="copy-btnLoad" @click="switchQuery(orderInfo.cuccSimIccid)">切换查询</button>
                </li>
                <li v-if="orderInfo.ctccSim && orderInfo.ctccSim.length>2">
                    <label>设备电信卡：</label>
                    <span>{{ orderInfo.ctccSim }}</span>
                    <button class="copy-btnLoad" @click="switchQuery(orderInfo.ctccSimIccid)">切换查询</button>
                </li>
                <li>
                    <label>代理商：</label>
                    <span>{{ orderInfo.agentName }}</span>
                </li>
                <li>
                    <label>套餐组：</label>
                    <span>{{ orderInfo.groupName }}</span>
                </li>
                <li>
                    <label>供应商：</label>
                    <span>{{ orderInfo.supplierName }}</span>
                </li>
            </ul>
        </section>


    </div>
</template>

<script>
import ShebeiMgr from './shebeiMgr.vue';
import { wxRequest } from "@/api/user";
import { Dialog } from "vant";
export default {
    components: {
        ShebeiMgr
    },
    data() {
        return {
            isShowDeviceManagement: false,
            userInfo: {
                mobile: ''
            },
            showFlg: false,
            orderInfo: {},
            copyMessage: '',
            activeCopyBtn: null
        }
    },
    created() {
        if (this.$route.query.mobile) {
            this.userInfo.mobile = this.$route.query.mobile;
            this.toSelectSimInfo()
        }
    },
    methods: {
        switchQuery(iccid) {
            this.userInfo.mobile=iccid;
            this.toSelectSimInfo();
        },
        toSelectSimInfo() {
            wxRequest("/kefu/select/simInfo", { iccid: this.userInfo.mobile }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.orderInfo = res.data.data;
                    localStorage.setItem('recordLoginText', this.userInfo.mobile)
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            });
        },
        showDeviceManagement() {
            if (this.orderInfo.iccid && this.orderInfo.iccid.length > 5) {
                this.iccid = this.orderInfo.iccid;
                localStorage.setItem('iccid', this.orderInfo.iccid)
                this.isShowDeviceManagement = true;
            } else {
                Dialog.alert({ message: '请先查询后 再来进行设备操作！' });
                return;
            }
        },
        updateSim() {
            if (!this.orderInfo.iccid) {
                Dialog.alert({ message: '请先查询后 再来进行操作！' });
                return;
            }
            wxRequest("/kefu/to/update", { iccid: this.orderInfo.iccid }, "get").then((res) => {
                if (res.data.code == 200) {
                    Dialog.alert({ message: '操作成功！' });
                    this.toSelectSimInfo();
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            });
        },
        toPause() {
            if (!this.orderInfo.iccid) {
                Dialog.alert({ message: '请先查询后 再来进行操作！' });
                return;
            }
            wxRequest("/kefu/to/pause", { iccid: this.orderInfo.iccid }, "get").then((res) => {
                if (res.data.code == 200) {
                    Dialog.alert({ message: '操作成功！' });
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            });
        },
        toActive() {
            if (!this.orderInfo.iccid) {
                Dialog.alert({ message: '请先查询后 再来进行操作！' });
                return;
            }
            wxRequest("/kefu/to/active", { iccid: this.orderInfo.iccid }, "get").then((res) => {
                if (res.data.code == 200) {
                    Dialog.alert({ message: '操作成功！' });
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            });
        },
        toReload() {
            if (!this.orderInfo.iccid) {
                Dialog.alert({ message: '请先查询后 再来进行操作！' });
                return;
            }
            wxRequest("/kefu/to/reload", { iccid: this.orderInfo.iccid }, "get").then((res) => {
                if (res.data.code == 200) {
                    Dialog.alert({ message: '操作成功！' });
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            });
        },
        copyToClipboard(text, event) {
            this.activeCopyBtn = event.currentTarget;

            if (navigator.clipboard) {
                navigator.clipboard.writeText(text).then(() => {
                    this.copyMessage = '复制成功';
                    this.handleCopySuccess();
                }).catch(err => {
                    console.error('使用 Clipboard API 复制失败: ', err);
                    this.fallbackCopyTextToClipboard(text);
                });
            } else {
                this.fallbackCopyTextToClipboard(text);
            }
        },
        fallbackCopyTextToClipboard(text) {
            const textArea = document.createElement("textarea");
            textArea.value = text;

            // 防止在 iOS 上调整大小
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    this.copyMessage = '复制成功';
                    this.handleCopySuccess();
                } else {
                    console.error('使用 fallback 方法复制失败');
                    this.copyMessage = '复制失败，请手动复制';
                }
            } catch (err) {
                console.error('使用 fallback 方法复制时出错: ', err);
                this.copyMessage = '复制失败，请手动复制';
            }

            document.body.removeChild(textArea);
        },
        handleCopySuccess() {
            // 重置所有复制按钮状态
            const copyButtons = document.querySelectorAll('.copy-btn');
            copyButtons.forEach(btn => {
                btn.querySelector('.copy-text').textContent = '复制';
                btn.classList.remove('copied');
            });

            // 设置当前按钮状态
            if (this.activeCopyBtn) {
                this.activeCopyBtn.querySelector('.copy-text').textContent = '已复制';
                this.activeCopyBtn.classList.add('copied');

                setTimeout(() => {
                    if (this.activeCopyBtn) {
                        this.activeCopyBtn.querySelector('.copy-text').textContent = '复制';
                        this.activeCopyBtn.classList.remove('copied');
                    }
                    this.copyMessage = '';
                }, 2000);
            }
        }
    },
    mounted() {
        // 导航栏点击事件处理
        document.querySelectorAll('.nav-link').forEach(link => {
            link.addEventListener('click', function (e) {
                if (this.getAttribute('href') !== 'http://wx.yunzhineng.top/#/user/loginSheMyUser') {
                    e.preventDefault();

                    // 更新导航栏激活状态
                    document.querySelectorAll('.nav-link').forEach(l => l.classList.remove('active'));
                    this.classList.add('active');
                }
            });
        });
    }
}
</script>

<style lang="less" scoped>
.returnPostage {
    padding: 15px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    margin-top: 50px;
    /* 为导航栏留出空间 */

    .navbar {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background: linear-gradient(135deg, #1a365d 0%, #2b4c7e 100%);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;

        .nav-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;

            .nav-links {
                display: flex;
                list-style: none;

                .nav-item {
                    margin: 0;

                    .nav-link {
                        display: block;
                        padding: 15px 25px;
                        color: white;
                        text-decoration: none;
                        font-weight: 600;
                        font-size: 16px;
                        transition: all 0.3s ease;
                        position: relative;
                        border-radius: 5px;

                        &:hover {
                            background-color: rgba(255, 255, 255, 0.1);
                            transform: translateY(-2px);
                        }

                        &.active {
                            background-color: rgba(255, 255, 255, 0.15);

                            &::after {
                                content: '';
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                width: 30px;
                                height: 3px;
                                background-color: #FFD166;
                                transform: translateX(-50%);
                            }
                        }
                    }
                }
            }
        }
    }

    .form-container {
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        padding: 15px;
        margin-bottom: 15px;
    }

    .form-group {
        margin-bottom: 20px;

        label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #333;
        }

        .input-wrapper {
            position: relative;

            input {
                width: 100%;
                padding: 12px 15px;
                border: 1px solid #ddd;
                border-radius: 8px;
                font-size: 16px;
                box-sizing: border-box;
                transition: border-color 0.3s ease;

                &:focus {
                    outline: none;
                    border-color: #007BFF;
                    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
                }

                &::placeholder {
                    color: #aaa;
                }
            }
        }
    }

    .button-group {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        margin-top: 25px;

        mt-button {
            padding: 14px 10px;
            border: none;
            border-radius: 8px;
            color: white;
            font-size: 15px;
            font-weight: 500;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            text-align: center;

            &:nth-child(5) {
                grid-column: span 2;
                max-width: 200px;
                justify-self: center;
            }

            &:hover {
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                transform: translateY(-2px);
            }

            &:active {
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                transform: translateY(0);
            }
        }

        .button-1 {
            background-color: gray;
        }

        .button-2 {
            background-color: #28a745;
        }

        .button-3 {
            background-color: #ffc107;
        }

        .button-4 {
            background-color: #dc3545;
        }

        .button-5 {
            background-color: #007BFF;
        }
    }

    ::v-deep .section1 {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        padding: 15px;

        .section-title {
            font-size: 18px;
            color: #333;
            margin-bottom: 15px;
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        li {
            display: flex;
            justify-content: space-between;
            padding: 12px 0;
            border-bottom: 1px solid #eee;

            &:last-child {
                border-bottom: none;
            }

            label {
                color: #555;
                font-weight: 500;
            }

            span {
                color: gray;
                ;
                font-weight: 500;
            }

            spanRed {
                color: red;
            }

            spanBul {
                color: blue;
            }
        }
    }

    .copy-btnLoad {
        background-color: #f0f0f0;
        border: none;
        border-radius: 5px;
        padding: 4px 8px;
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        transition: all 0.3s ease;

        i {
            color: #555;
        }

        .copy-text {
            font-size: 12px;
            color: #555;
        }

        &:hover {
            background-color: #e0e0e0;
        }

        &.copied {
            background-color: #28a745;

            i,
            .copy-text {
                color: white;
            }
        }
    }

    .with-copy-btn {
        .value-wrapper {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .copy-btn {
            background-color: #f0f0f0;
            border: none;
            border-radius: 5px;
            padding: 4px 8px;
            display: flex;
            align-items: center;
            gap: 4px;
            cursor: pointer;
            transition: all 0.3s ease;

            i {
                color: #555;
            }

            .copy-text {
                font-size: 12px;
                color: #555;
            }

            &:hover {
                background-color: #e0e0e0;
            }

            &.copied {
                background-color: #28a745;

                i,
                .copy-text {
                    color: white;
                }
            }
        }
    }

    /* 响应式设计 */
    @media (max-width: 768px) {
        .navbar .nav-links {
            flex-wrap: wrap;
        }

        .navbar .nav-item {
            flex: 1 1 50%;
            text-align: center;
        }

        .navbar .nav-link {
            padding: 15px;
        }

        .navbar .nav-link.active::after {
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>

<style lang="less" scoped>
.page {
    // height: 100vh;
    background: #F5F6F7;

    .ytop {
        height: 260px;
        background: url('../../assets/img/she/bg_sbgl.png')no-repeat top center;
        background-size: 100% 100%;

        .title {
            display: flex;
            height: 40px;
            align-items: center;

            .img {
                width: 25px;
                height: 25px;
                margin-left: 7px;
            }

            .c-data {
                text-align: center;
                color: #fff;
                font-size: 18px;
                width: calc(100% - 32px);
                font-weight: bold;
            }
        }

        .logo {
            margin-top: 18px;
            display: flex;
            align-items: center;

            img {
                width: 65px;
                height: 65px;
                border-radius: 100%;
                margin-left: 14px;
                margin-right: 14px;
            }

            .user-name {
                width: calc(100% - 93px);
                color: #fff;

                .name {
                    font-size: 18px;
                    margin-bottom: 12px
                }

                .time {
                    font-size: 13px;
                }
            }
        }

        .top-content {
            height: 96px;
            border-radius: 10px;
            background: #fff;
            display: flex;
            width: 90%;
            margin: 0 auto;
            align-items: center;
            justify-content: space-around;
            margin-top: 18px;

            .used {
                text-align: center;

                .used-total-num {
                    font-size: 24px;
                    margin-bottom: 14px;
                    font-weight: bold;

                    span {
                        font-size: 13px;
                        font-weight: normal;
                    }
                }

                .used-total-CN {
                    font-size: 13px;
                }
            }
        }
    }

    .device {
        margin: 0 auto;
        background: #fff;
        width: 90%;
        border-radius: 10px;
        position: relative;

        .today {
            display: flex;
            padding: 15px;
            align-items: center;

            &:nth-child(2) {
                padding-top: 0;
            }

            .wifi {
                font-size: 14px;
                padding-left: 7px;
                padding-right: 12px;
            }

            .wifi-gb {
                font-size: 20px;
                color: #FF533B;
                font-weight: bold;

                span {
                    color: #000;
                    font-size: 14px;
                    font-weight: normal;
                    padding-left: 6px;
                }
            }
        }

        .device-state {
            font-size: 12px;
            position: absolute;
            right: 0;
            width: 80px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            top: 32px;
        }

        .device-bg {
            color: #888888;
            background: url('../../assets/img/she/bg_lx.png') no-repeat center;
            background-size: 100% 100%;
        }

        .device-bg1 {
            color: #3EC230;
            background: url('../../assets/img/she/bg_lx1.png') no-repeat center;
            background-size: 100% 100%;
        }
    }

    .quantity {
        background: #fff;
        padding: 0 18px;
        display: flex;
        align-items: center;

        img {
            width: 28px;
            height: 28px;
            margin-right: 20px;
        }
    }

    .content-edit1 {
        width: 90%;
        // height: 329px;
        margin: 15px auto;
        background: #fff;
        padding: 18px 0;
        border-radius: 10px;

        .title-flex {
            display: flex;
            padding: 0 15px;
            justify-content: space-between;

            .big {
                font-size: 16px;
                font-weight: 500;
                position: relative;
                margin-left: 10px;

                &::before {
                    content: '';
                    height: 15px;
                    left: -10px;
                    width: 3px;
                    background: #FF4C37;
                    border-radius: 2px;
                    position: absolute;

                }
            }

            .big-btn {
                background: url('../../assets/img/she/bt_qrxg.png') no-repeat center;
                background-size: 100% 100%;
                width: 70px;
                height: 25px;
                text-align: center;
                font-size: 13px;
                color: #fff;
                line-height: 24px;
            }
        }

        .btn22 {
            justify-content: center;
            display: flex;
            width: 85%;
            align-items: center;
            margin: 0 auto;

            div {
                text-align: center;
                line-height: 38px;
                flex: 1;
                border: 1px solid #f27c6a;
                border-radius: 20px;

                &:nth-child(1) {
                    margin-right: 20px;
                }

                img {
                    vertical-align: middle;
                }
            }
        }

        .form-flex {
            margin: 0 15px;
            background: #F5F6F7;
            height: 50px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            margin-top: 14px;

            .label {
                width: 30%;
                text-align: center;
                font-size: 15px;
                font-family: Source Han Sans CN;
            }

            .value {
                background: none;
                width: 70%;
                font-size: 15px;
            }
        }

        .operator {
            height: 55px;
            border-radius: 7px;
            border: 1px solid #FFFBFA;
            background: #F0E3E1;
            margin: 0 15px;
            margin-top: 14px;
            display: flex;
            position: relative;
            align-items: center;

            img {
                margin: 0 16px;
            }

            .operator-name {
                font-size: 16px;
                margin-right: 10px;
            }

            .operator-type {
                font-size: 12px;
                text-align: center;
                height: 16px;
                width: 50px;
                line-height: 16px;
                color: #fff;
            }

            .operator-type-seccess {
                background: url('../../assets/img/she/bg_ysm.png') no-repeat center;
                background-size: 100% 100%;
            }

            .operator-type-waring {
                background: url('../../assets/img/she/icon_wsm.png') no-repeat center;
                background-size: 100% 100%;
            }

            .operator-state {
                color: #FF533B;
                font-size: 12px;
                position: absolute;
                right: 12px;
            }
        }

        .is-active {
            background: url('../../assets/img/she/select.png') no-repeat center;
            background-size: 100% 100%;
        }
    }

    .footer-hi {
        font-size: 13px;
        color: #666;
        font-weight: 500;
        width: 90%;
        margin: 15px auto 12px auto;
    }

    .xsdw {
        color: #666;
        font-size: 12px;
        width: 90%;
        margin: 0 auto 12px auto;
        line-height: 20px;
    }
}

.el-tip {
    padding: 14px;
    line-height: 1.5;
    color: #333;
    font-size: 14px;
}
</style>

